import React, {useState, useEffect, useCallback, useContext, memo, Fragment } from 'react';
import {    
            Backdrop,
            Box,
            Button,
            Chip,
            CircularProgress,
            Collapse,
            Fab,
            Grid,
            IconButton,
            Menu,
            MenuItem,
            Paper,
            Table,
            TableBody,
            TableCell,
            TableContainer,
            TableHead,
            TableRow,
            TableSortLabel,
            TextField,
            Tooltip,
            Typography,
            Switch,
            withWidth
        } from '@material-ui/core';
import { 
            AccountBalance as AccountBalanceIcon,        
            AttachMoney as AttachMoneyIcon,
            Block as BlockIcon,
            CheckCircle as CheckCircleIcon,
            Cached as CachedIcon,
            Clear as ClearIcon,
            Delete as DeleteIcon,
            DoneOutline as DoneOutlineIcon,
            Event as EventIcon,
            KeyboardArrowUp as KeyboardArrowUpIcon,
            KeyboardArrowDown as KeyboardArrowDownIcon,
            LocalAtm as LocalAtmIcon,
            Message as MessageIcon,
            MonetizationOn as MonetizationOnIcon,
            MoreVert as MoreVertIcon,
            PictureAsPdf as PictureAsPdfIcon,
            Receipt as RecieptIcon,
            Refresh as RefreshIcon,
            Save as SaveIcon,
            Search as SearchIcon,
            Today as TodayIcon,
        } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {    Autocomplete    } from '@material-ui/lab';
import { red, blue, teal } from '@material-ui/core/colors';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from '../Auth';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
// import { StoreContext } from '../Store/StoreProvider';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
import helperDatos from './helpers/helperDatos';
import { 
    Avatar, 
    Button as ButtonAntd,
    Checkbox as CheckboxAntd,
    Modal as ModalAntd,
    Segmented,
    Switch as SwitchAntd,
    Table as TableAntd,
    Tag,
    Tooltip as TooltipAntd,
    Typography as TypographyAntd,
    Upload
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PdfReciept from '../Elementos/PdfReciept';
import PdfInvoice from '../Elementos/PdfInvoice';
import PdfThermal from '../Elementos/PdfThermal';

const { Title } = TypographyAntd;

const columnsSearch = [
    {
        title: 'Cliente',
        dataIndex: 'Nombres',
        key: 'Nombres',
    },
    {
        title: 'Cedula',
        dataIndex: 'CI',
        key: 'CI',
    },
    {
        title: 'idForMikrotik',
        dataIndex: 'idForMikrotik',
        key: 'idForMikrotik',
    },
    {
        title: 'Zona Cliente',
        dataIndex: 'ZonaService',
        key: 'ZonaService',
    },
];

const arrMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const arrMeses2 = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];



const moment = require('moment-timezone');

const styles = makeStyles((theme)=>({
    CI:{
        color:red[500]
    },
    fabSearch:{
        backgroundColor:blue[500],
        margin: 'auto'
    },
    paper:{
        padding:20,
        minHeight:'60vh',
        width:'100%',
        
    },
    button:{
        color:'#fff'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    container: {
        maxHeight: 550,
        overflow:'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

const columns = [
    { id: 'Factura', label: 'Options', minWidth: 210,numeric: false, disablePadding: false },
    { id: 'NumberReciept', label: 'Numero', minWidth: 170,numeric: false, disablePadding: false },
    { id: 'MesServicio', label: 'Mes Servicio', minWidth: 170,numeric: false, disablePadding: false },
    { id: 'Status', label: 'Status', minWidth: 100, numeric: false, disablePadding: false },
    { id: 'Valor', label: 'Pagado', minWidth: 140, align: 'right', numeric: true, disablePadding: false}, 
    { id: 'ValorMes', label: 'Pendiente', minWidth: 140, align: 'right', numeric: true, disablePadding: false}, 
    { id: 'Action', label: 'Action', minWidth: 170, align: 'right', numeric: false, disablePadding: false}, 
];

const columnsSmall = [
    { id: 'NumberReciept', label: 'Numero', minWidth: 100,numeric: false, disablePadding: false },
    { id: 'MesServicio', label: 'Mes Servicio', minWidth: 150,numeric: false, disablePadding: false },
    { id: 'Action', label: 'Action', minWidth: 170, align: 'right', numeric: false, disablePadding: false}, 
];

const ButtonPay = memo(({
    authTokens,
    getBancos,
    getInfoEmpresa,
    handleUpdate, 
    isInvoices, 
    isSyncMk,
    rowInfo, 
    serviceSelected, 
    zonaObject, 
})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ isProcessingPay, setProcessingPay ] = useState(false);
    const [ refPago, setRefPago ] = useState('');
    const [ fecPago, setfecPago ] = useState('');
    const [ tipoPago, setTipoPago ] = useState('Efectivo');
    const [ isReadyRef, setReadyRef ] = useState(false);
    const [ diaPago, setDiaPago ] = useState('SI');
    const [ openReferenciaPagos, setOpenReferenciaPagos ] = useState(false);
    const [ openFechaPago, setOpenFechaPago ] = useState(false);
    const [ isBancario, setBancario ] = useState(false);
    const [ openDiaPago, setOpenDiaPago ] = useState(false);
    const [ openModalBancario, setOpenModalBancario ] = useState(false);
    const [ isValidandoDeposito, setValidandoDeposito ] = useState(false);
    const [ getBanco, setBanco ] = useState('');
    const [ getVoucher, setVoucher ] = useState('');
    const [ isValidandoVoucher, setValidandoVoucher ] = useState(false);
    const [ openModalVoucher, setOpenModalVoucher ] = useState(false);
    const [ fileList, setFileList] = useState([]);
    const [ uploading, setUploading] = useState(false);
    const [ getNombreImagen, setNombreImagen ] = useState('');
    const [ isPhoto, setPhoto ] = useState(false);
    const [ isVoucher, setIsVoucher ] = useState(false);
    const [ isPaying, setPaying ] = useState(false);
    const [ isReadyPdfThermal, setReadyPdfThermal ] = useState(false);
    const [ openPrint, setOpenPrint ] = useState(false);
    const [ getDataThermal, setDataThermal ] = useState({});

    useEffect(()=>{
        if(isReadyRef){
            setReadyRef(false);
            if(tipoPago === 'Bancario'){
                handleValidarDeposito();
            }else{
                if(isVoucher){
                    handleValidarVoucher();
                }else{
                    handlePagar();
                }
            }
            
        }
    },[isReadyRef]) // eslint-disable-line react-hooks/exhaustive-deps


    const handleFechaPago = ()=>{
        setProcessingPay(true);
        setOpenDiaPago(true);
    }

    const handlePagar = ()=>{
        const laZona="America/Guayaquil";
        const laFecha = moment().tz(laZona).format();
        const objeto = {...rowInfo};
        objeto.numVoucher = getVoucher;
        objeto.Banco = getBanco;
        objeto.RefPago= refPago;
        objeto.TipoPago = tipoPago;
        objeto.FechaPago = fecPago;
        objeto.InfoZona = zonaObject;
        objeto.serviceSelected = serviceSelected;
        objeto.Plan = serviceSelected.Plan;
        objeto.Status = 'Pagado';
        objeto.idFromMikrotik = serviceSelected.idFromMikrotik;
        objeto.Modificacion = laFecha;
        objeto.Valor = rowInfo.ValPlan;
        objeto.isPhoto = isPhoto;
        objeto.urlPhoto = `/refBancarias/${getNombreImagen}`;
        objeto.isSyncMk = isSyncMk;
        objeto.Recaudador = authTokens.Nombres;
        objeto.RecaudadorR = authTokens.NombresReducidos;
        const valGuide = parseInt(rowInfo.Valor);
        const objeto_ = {...rowInfo};
        const valPay_ = parseFloat(rowInfo.ValPlan - (valGuide > 0 ? rowInfo.Valor : valGuide));
        console.log(valPay_);
        const valPay = parseFloat(valPay_).toFixed(2);
        objeto_.Status = rowInfo.Status === 'Pendiente' && valGuide > 0 ? 'PagoRestante' : rowInfo.Status;
        objeto_.Valor = rowInfo.Status === 'Pendiente' && valGuide > 0 ? valPay : rowInfo.ValPlan;
        setDataThermal(objeto_);
        fetch('/api/recibos/pagar',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            //console.log(result);
            if(result._id){
                enqueueSnackbar(result.message,{variant:'success'});
                setDiaPago('SI');
                setTipoPago('Efectivo');
                setRefPago('');
                setOpenModalBancario(false);
                setOpenFechaPago(false);
                setOpenReferenciaPagos(false);
                setOpenModalVoucher(false);
                setOpenDiaPago(false);
                handleUpdate(result);
                
                setTimeout(()=>{
                    setProcessingPay(false);
                    setPaying(false);
                },500);
                console.log(objeto_);
                setOpenPrint(true);
            }else{
                enqueueSnackbar(result.status,{variant:'error'});
                setProcessingPay(false);
            }
            
        });
        
        
    };

    const handleValidarDeposito = ()=>{      
        fetch('/api/recibos/validarDeposito',{ method:'POST', body: JSON.stringify({refPago:refPago}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message,{variant:'success'});
                setTimeout(()=>{
                    setValidandoDeposito(false);
                    handlePagar();
                },1000);
            }else{
                setValidandoDeposito(false);
                setPaying(false);
                Swal.fire({
                    title: result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
        })
    };

    const handleValidarVoucher = ()=>{    
        fetch('/api/recibos/validarVoucher',{ method:'POST', body: JSON.stringify({numVoucher:getVoucher}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message,{variant:'success'});
                setTimeout(()=>{
                    setValidandoVoucher(false);
                    handlePagar();
                },1000)
                ();
            }else{
                setValidandoVoucher(false);
                Swal.fire({
                    title: result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
        })
    };

    const handleDiaPago = (value)=>{
        setDiaPago(value);
    };

    const handleContinuoDiaPago = ()=>{
        if(diaPago === 'SI'){
            const laZona="America/Guayaquil";
            const laFecha = moment().tz(laZona).format();
            setfecPago(laFecha.split('T')[0]);
            setOpenReferenciaPagos(true);
        }else{
            setOpenFechaPago(true);
        }
    };

    const handleClosePago = ()=>{
        setDiaPago('SI');
        setOpenDiaPago(false);
        setProcessingPay(false);
        setTipoPago('Efectivo');
        setBanco('');
    };

    const handleCloseFechaPago = ()=>{
        setOpenFechaPago(false);
    };

    const handleReferenciaPago = (value)=>{
        if(value === 'Efectivo'){
            setBancario(false);
            setTipoPago(value);
        }else{
            setBancario(true);
            setTipoPago(value);
        }
    };

    const handleContinuoRef = ()=>{
        if(isBancario){
            setOpenModalBancario(true);
        }else{
            if(isVoucher){
                setOpenModalVoucher(true);
            }else{
                setReadyRef(true);
                setPaying(true);
            }
            
        }
    };

    const handleCloseModalBancario = ()=>{
        setOpenModalBancario(false);
        setRefPago('');
        setBanco('');
    };

    const handleCloseTipoPago = ()=>{
        setTipoPago('Efectivo');
        setBancario(false);
        setRefPago('');
        setBanco('');
        setOpenReferenciaPagos(false);   
    };

    const handleCloseModalVoucher = ()=>{
        setOpenModalVoucher(false);
        setVoucher('');
    };

    const propsUpload = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([...fileList, file]);
            return false;
        },
            fileList,
    };

    const handleUpload = () => {
        if(isPhoto){
            setPaying(true);
            const formData = new FormData();
            fileList.forEach((file) => {
                const d = new Date ();
                const nombreImagen = `${serviceSelected.idForMikrotik}_${rowInfo.MesServicio}_${rowInfo.ageWork}_${d.getTime()}.${file.name.split('.').pop().toString()}`;
                setNombreImagen(nombreImagen);
                formData.append('file', file, nombreImagen);
            });
            setUploading(true); // You can use any AJAX library you like
        
            fetch('/api/uploadRefPago', {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((result) => {
                if(result.message){
                    setFileList([]);
                    enqueueSnackbar('Depósito Subido',{variant:'success'});
                    setReadyRef(true);
                }else{
                    enqueueSnackbar('Fallo con el Servidor',{variant:'error'});
                }
              })
              .catch(() => {
                enqueueSnackbar('Fallo con el Servidor',{variant:'error'});
                setPaying(false);
              })
              .finally(() => {
                setUploading(false);
              });
        }else{
            setReadyRef(true);
            setPaying(true);
        }
        
    };

    const handleCreatePdfThermal = ()=>{ setReadyPdfThermal(true) };

    const handleClickPdfThermal = ()=>{
        setTimeout(()=>{
            setReadyPdfThermal(false);
        },1000);
    };

    return(
        <React.Fragment>
            <ModalAntd 
                title="Hoy se Efectuo el Pago?" 
                visible={openDiaPago} 
                onCancel={handleClosePago} 
                onOk={handleContinuoDiaPago} 
                okText='CONTINUAR'
                cancelText='CANCELAR'
                destroyOnClose
                bodyStyle={{display:'flex', justifyContent:'center', minHeight:130}}
                >
                <Segmented 
                        style={{ height:63}}
                        value={diaPago || 'SI'}
                        onChange={handleDiaPago}
                        size='small'
                        options={[
                            {
                            label: (
                                <div style={{ padding: 4 }}>
                                <Avatar style={{ backgroundColor: '#87d068', paddingTop:3 }}  icon={<DoneOutlineIcon fontSize='small' />}/>
                                <div>SI</div>
                                </div>
                            ),
                            value: 'SI',
                            },
                            {
                            label: (
                                <div style={{ padding: 4 }}>
                                <Avatar style={{ backgroundColor: 'MediumSeaGreen', paddingTop:3 }} icon={<TodayIcon fontSize='small' />}/>
                                <div>NO</div>
                                </div>
                            ),
                            value: 'NO',
                            },
                        ]}
                    />
            </ModalAntd> 
            <ModalAntd 
                title="FECHA DE PAGO" 
                visible={openFechaPago} 
                onCancel={handleCloseFechaPago} 
                onOk={()=>{setOpenReferenciaPagos(true)}} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                bodyStyle={{display:'flex', justifyContent:'center'}}
                destroyOnClose
                >
                    <TextField
                        autoFocus
                        label='FECHA'
                        fullWidth
                        onChange={({target})=>{setfecPago(target.value);}}
                        value={fecPago || ''}
                        type='date'
                        size='small'
                        variant='outlined'                                    
                    />
                
            </ModalAntd> 
            <ModalAntd 
                title="TIPO DE PAGO" 
                visible={openReferenciaPagos} 
                onCancel={handleCloseTipoPago} 
                onOk={handleContinuoRef} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                destroyOnClose
                bodyStyle={{display:'flex', justifyContent:'center'}}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <Grid container justifyContent='center'>
                        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
                            <Segmented 
                                value={tipoPago || ''}
                                onChange={handleReferenciaPago}
                                size='small'
                                options={[
                                    {
                                    label: (
                                        <div style={{ padding: 4 }}>
                                        <Avatar style={{ backgroundColor: '#87d068', paddingTop:3 }}  icon={<LocalAtmIcon fontSize='small' />}/>
                                        <div>EFECTIVO</div>
                                        </div>
                                    ),
                                    value: 'Efectivo',
                                    },
                                    {
                                    label: (
                                        <div style={{ padding: 4 }}>
                                        <Avatar style={{ backgroundColor: 'MediumSeaGreen', paddingTop:3 }} icon={<AccountBalanceIcon fontSize='small' />}/>
                                        <div>BANCARIO</div>
                                        </div>
                                    ),
                                    value: 'Bancario',
                                    },
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={1} justifyContent='center' alignItems='center'>
                                <Grid item>
                                    SIN VOUCHER
                                </Grid>
                                <Grid item>
                                    <Switch checked={isVoucher} onChange={({target})=>{ setIsVoucher(target.checked)}} name="isVoucher" color='primary'/>
                                </Grid>
                                <Grid item>
                                    CON VOUCHER
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
            </ModalAntd> 
            <ModalAntd 
                title="REFERENCIA BANCARIA" 
                visible={openModalBancario} 
                onCancel={handleCloseModalBancario} 
                onOk={handleUpload} 
                okText='VALIDAR'
                cancelText='RETROCEDER'
                destroyOnClose
                confirmLoading={isValidandoDeposito}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <React.Fragment>
                        <TextField
                            id='Banco'
                            fullWidth
                            label='Banco'
                            value={getBanco || ''}
                            onChange={({target})=>{setBanco(target.value)}}
                            variant='outlined'
                            size='small'   
                            select  
                            style={{margin:10}}                    
                        >
                            
                            {getBancos.map((el)=>
                                <MenuItem value={el.Banco} key={el._id}>
                                    {el.Banco}
                                </MenuItem>
                            )}
                        </TextField>
                        <TextField
                            id='refPago'
                            fullWidth
                            label='Num. Comprobante Pago'
                            value={refPago || ''}
                            onChange={({target})=>{setRefPago(target.value)}}
                            variant='outlined'
                            size='small'     
                            style={{margin:10}}                 
                        />
                        <Grid container  alignItems="center" spacing={1} style={{margin:10}} justifyContent='center'>
                            <Grid item>NO FOTO</Grid>
                            <Grid item>
                                <Switch checked={isPhoto} onChange={({target})=>{ setPhoto(target.checked)}} name="isPhoto" color='primary'/>
                            </Grid>
                            <Grid item>FOTO</Grid>
                        </Grid>

                        {isPhoto ?
                        <Upload {...propsUpload} >
                            <ButtonAntd 
                                style={{margin:10}} 
                                icon={<UploadOutlined />}
                                loading={uploading}
                            >{uploading ? 'Subiendo' : 'Adjuntar Depósito'}
                            </ButtonAntd>
                        </Upload> : null}
                    </React.Fragment>
            </ModalAntd> 
            <ModalAntd 
                title="VOUCHER" 
                visible={openModalVoucher} 
                onCancel={handleCloseModalVoucher} 
                onOk={()=>{ setReadyRef(true); setPaying(true); }} 
                okText='VALIDAR'
                cancelText='RETROCEDER'
                destroyOnClose
                confirmLoading={isValidandoVoucher}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <React.Fragment>
                        <TextField
                            id='numVoucher'
                            fullWidth
                            label='NUM. VOUCHER'
                            value={getVoucher || ''}
                            onChange={({target})=>{setVoucher(target.value)}}
                            variant='outlined'
                            size='small'     
                                           
                        />
                        
                    </React.Fragment>
                    
                
            </ModalAntd> 
            <ModalAntd 
                title="IMPRIMIR COMPROBANTE" 
                visible={openPrint} 
                onCancel={()=>{setOpenPrint(false)}} 
                onOk={()=>{setOpenPrint(false)}} 
                okText='CERRAR'
                cancelText='...'
                bodyStyle={{display:'flex', justifyContent:'center'}}
                showCancelButton={false}
                cancelButtonProps={{disabled:true}}
                destroyOnClose
                >
                    <Grid container justifyContent='center' spacing={2}>
                        <Grid item xs={12} style={{display:'grid', placeContent:'center'}}>
                            <img src="./ok.svg" alt ='PAGO REALIZADO'/>
                        </Grid>
                        <Grid item xs={12} style={{display:'grid', placeContent:'center'}}>
                            <Title level={3}>Pago Realizado</Title>
                        </Grid>
                        <Grid item style={{display:'grid', placeContent:'center'}}>
                            <Tooltip title='IMPRIMIR COMPROBANTE' arrow>
                                <span>
                                    <IconButton size="small" color='primary' onClick={handleCreatePdfThermal} style={{backgroundColor:'gainsboro'}}>
                                        <RecieptIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            {isReadyPdfThermal && <PdfThermal data={getDataThermal} HandleClickPdf={handleClickPdfThermal} InfoEmpresa={getInfoEmpresa} Service={serviceSelected} isSmall={true}/>}
                        </Grid>

                    </Grid>
                    
                    
                
            </ModalAntd> 
            <Tooltip title={'Pagar'} arrow placement={'right'}>
                <span>
                <Button 
                size='small' 
                variant='contained' 
                color='primary' 
                disabled={rowInfo.Status === 'Pagado' || rowInfo.Status === 'Start' || isInvoices ? true : false || rowInfo.Status === 'Anulado' || isProcessingPay } 
                onClick={handleFechaPago} >                   
                    { isProcessingPay ? <FacebookCircularProgress size={12} style={{marginTop:5}}/>
                        : <AttachMoneyIcon style={{color:'#fff'}}/>
                    }
                </Button>  
                </span>
            </Tooltip>
        </React.Fragment>
        
    )
});

const ValorMes = memo(({
    authTokens,
    getBancos,
    handleUpdate,
    isInvoices, 
    isSyncMk,
    rowInfo, 
    serviceSelected, 
    zonaObject, 
})=>{
    const [ isValue, setValue ] = useState('');
    const [ refPago, setRefPago ] = useState('');
    const [ tipoPago, setTipoPago ] = useState('');
    const [ fecPago, setfecPago ] = useState('');
    const [ isReadyRef, setReadyRef ] = useState(false);
    //const [ isPromesaPagoRef, setPromesaPagoRef ] = useState(false);
    //const [ promesaPago, setPromesaPago ] = useState('');
    const [ isEdit, setEdit ] = useState(false);
    const [ valueBackup, setValueBackup ] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    //const { authTokens } = useAuth();

    useEffect(()=>{
        if(rowInfo._id){
            if(rowInfo.isPromise){
                setValue(rowInfo.Valor);
                setValueBackup(rowInfo.Valor);
            }else{
                let number = 0;
                setTimeout(() => {
                    setValue(number);
                    setValueBackup(number);
                }, 500);
            }
        }else{
            setValue(0);    
            setValueBackup(0);
        }
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isReadyRef){
            setReadyRef(false);
            if(tipoPago === 'Bancario'){
                handleValidarDeposito();
            }else{
                handleSave();
            }
           
        }
    },[isReadyRef])// eslint-disable-line react-hooks/exhaustive-deps

    const handleEdit = ()=>{
        if(rowInfo.Status === 'Pagado'){
            enqueueSnackbar('No Puede Abonar',{variant:'info'});
        }else{
            setEdit(true);
        }   
    };

    const handleChange = (e)=>{ setValue(e.target.value); };

    const handleSave = ()=>{
        swal({
            title: "Promesa de Pago",
            icon:'info',
            text:'Desea Realizar una promesa de Pago?',
            buttons: {
                cancel: 'Cancelar',
                catch: {
                    text: "Sin Promesa",
                    value: "NoPromesa",
                  },
                Promesa: true,
              },
        }).then((Promesa)=>{
            switch(Promesa){
                case'NoPromesa':
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    const objeto = {...rowInfo};
                    objeto.RefAbono= refPago;
                    objeto.TipoPago = tipoPago;
                    objeto.FechaAbono = fecPago;
                    objeto.InfoZona = zonaObject;
                    objeto.serviceSelected = serviceSelected;
                    objeto.TipoServicioMk = serviceSelected.TipoServicioMk;
                    objeto.Status = 'Pendiente';
                    objeto.idFromMikrotik = serviceSelected.idFromMikrotik;
                    objeto.Plan = serviceSelected.Plan;
                    objeto.Modificacion = laFecha;
                    objeto.Valor = rowInfo.Valor ?  rowInfo.Valor + parseInt(isValue) : parseInt(isValue);
                    objeto.isSyncMk = isSyncMk;
                    objeto.Recaudador = authTokens.Nombres;
                    objeto.RecaudadorR = authTokens.NombresReducidos;
                    objeto.RecaudadorDate = laFecha;
                    fetch('/api/recibos/abonar',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        //console.log(result);
                        if(result.message){
                            setTipoPago('');
                            setRefPago('');
                            handleUpdate(objeto);
                            swal('Abono Realizado Sin Promesa','','success');
                            setEdit(false);                               
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});
                            setEdit(false);    
                        }
                        
                    });
                    break;
                case 'Promesa':
                    swal({
                        title: "Ingrese la Fecha de corte",
                        content: {
                            element: "input",
                            attributes: {
                            placeholder: "Referencia",
                            type: "date",
                            },
                        },
                        button:{
                            text:'Confirmar',
                            closeModal: false,
                        }
                    }).then((value2)=>{
                        //console.log(value2);
                        if(value2 === '' || value2 === null){
                            const laZona="America/Guayaquil";
                            const laFecha = moment().tz(laZona).format();
                            const objeto = {...rowInfo};
                            objeto.RefAbono= refPago;
                            objeto.TipoPago = tipoPago;
                            objeto.FechaAbono = fecPago;
                            objeto.InfoZona = zonaObject;
                            objeto.serviceSelected = serviceSelected;
                            objeto.Status = 'Pendiente';
                            objeto.Modificacion = laFecha;
                            objeto.Valor = rowInfo.Valor ?  rowInfo.Valor + parseInt(isValue) : parseInt(isValue);
                            objeto.whoPromise = authTokens.Nombres;
                            objeto.whoPromiseR = authTokens.NombresReducidos;
                            objeto.whoPromiseDate = laFecha;
                            objeto.isSyncMk = isSyncMk;
                            objeto.Recaudador = authTokens.Nombres;
                            objeto.RecaudadorR = authTokens.NombresReducidos;
                            objeto.RecaudadorDate = laFecha;
                            objeto.TipoServicioMk = serviceSelected.TipoServicioMk;
                            fetch('/api/recibos/abonar',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                            .then(response=> response.json())
                            .then(result =>{
                                //console.log(result);
                                if(result.message){
                                    setTipoPago('');
                                    setRefPago('');
                                    handleUpdate(objeto);
                                    swal('Abono Realizado Sin Promesa','','info');
                                    setEdit(false);                               
                                }else{
                                    enqueueSnackbar(result.status,{variant:'error'});
                                    setEdit(false);    
                                }
                                
                            });
                        }else{
                            const laZona="America/Guayaquil";
                            const laFecha = moment().tz(laZona).format();
                            const objeto = {...rowInfo};
                            objeto.RefAbono= refPago;
                            objeto.TipoPago = tipoPago;
                            objeto.FechaAbono = fecPago;
                            objeto.InfoZona = zonaObject;
                            objeto.serviceSelected = serviceSelected;
                            objeto.Status = 'Pendiente';
                            objeto.Modificacion = laFecha;
                            objeto.Valor = rowInfo.Valor ?  rowInfo.Valor + parseInt(isValue) : parseInt(isValue);
                            objeto.isPromise = true;
                            objeto.fechaCortePromesa = value2.toString();
                            objeto.isSyncMk = isSyncMk;
                            objeto.Recaudador = authTokens.Nombres;
                            objeto.RecaudadorR = authTokens.NombresReducidos;
                            objeto.RecaudadorDate = laFecha;
                            objeto.TipoServicioMk = serviceSelected.TipoServicioMk;
                            fetch('/api/recibos/abonar',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                            .then(response=> response.json())
                            .then(result =>{
                                //console.log(result);
                                if(result.message){
                                    setTipoPago('');
                                    setRefPago('');
                                    handleUpdate(objeto);
                                    swal('Abono y Promesa Realizados','','success');
                                    setEdit(false);                               
                                }else{
                                    enqueueSnackbar(result.status,{variant:'error'});
                                    setEdit(false);    
                                }
                                
                            });
                        }
                        
                    });
                    break;
                default:
                    swal("Abono Anulado");
            }
        });

    };

    const handleCancel = ()=>{
        setEdit(false);
        setValue(valueBackup);
    };

    const handleFechaPago = ()=>{
        swal({
            title: "Hoy se Efectuo el Abono?",
            buttons: {
                No: true,
                Si:true,
              },
        })
        .then((value) => {
            //console.log(value);
            switch(value){
                case'Si': 
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    setfecPago(laFecha);
                    handleAlertRefPago(); 
                    break;
                case 'No':
                    swal({
                        title: "Ingrese la Fecha de Pago",
                        content: {
                          element: "input",
                          attributes: {
                            type: "date",
                          },
                        },
                    }).then((value2)=>{
                        if(value2){
                            setfecPago(value2);
                            handleAlertRefPago(); 
                        }else{
                            setfecPago('');
                        }
                    });
                    break;
                default: 
                    setfecPago('');
                    setEdit(false);
                    setValue(valueBackup);
                    break;
            }
        });
    };

    const handleAlertRefPago = ()=>{
        swal({
            title: "Seleccione el tipo de Abono",
            buttons: {
                cancel: "Cancelar",
                Efectivo: true,
                Bancario: true,
              },
        })
        .then((value) => {
            switch(value){
                case'Efectivo': 
                    setTipoPago('Efectivo');
                    setReadyRef(true);                                  
                    break;
                case 'Bancario':
                    setTipoPago('Bancario');
                    swal({
                        title: "Ingrese la Referencia de Pago",
                        content: {
                            element: "input",
                            attributes: {
                            placeholder: "Referencia",
                            type: "text",
                            },
                        },
                    }).then((value2)=>{
                        if(value2 !== ''){
                            setRefPago(value2);
                            setReadyRef(true); 
                        }else{
                            setTipoPago('');
                        }
                    });
                    break;
                default: 
                    break;
            }
        });
    };

    const handleValidarDeposito = ()=>{
        fetch('/api/recibos/validarDeposito',{ method:'POST', body: JSON.stringify({refPago:refPago}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message,{variant:'success'});
                handleSave();
            }else{
                Swal.fire({
                    title: result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
        })
    };

    if(isEdit){
        return(
            <div style={{height:30, width:140}}>      
                <TextField
                    value={isValue}
                    onChange={handleChange}
                    margin='dense'
                    size='small'
                    style={{width:50, marginTop:-1, padding:0}}
                />
                <IconButton size='small' onClick={handleFechaPago} style={{ marginLeft:2,marginRight:2}}>
                    <Tooltip title='Guardar' arrow placement='top'>
                        <SaveIcon style={{color:'#fff'}} />
                    </Tooltip>
                </IconButton>
                <IconButton size='small' onClick={handleCancel}>
                    <Tooltip title='Cancelar' arrow placement='right'>
                        <ClearIcon style={{color:'#fff'}}/>
                    </Tooltip>
                </IconButton>
            </div>
        )
    }else{
        return(   
            
                <Tooltip title={rowInfo.Status === 'Pagado' ? 'Pagado' :'Abonar'} arrow placement='right'>
                    <span>
                        <Button onClick={handleEdit} size='medium' disabled={isInvoices} color='primary' variant='contained'>
                            $ { 
                                rowInfo.Status === 'Pagado' ?
                                rowInfo.ValTotal ? rowInfo.ValTotal : parseFloat(rowInfo.ValPlan).toFixed(2) :
                                rowInfo.Valor ? 
                                rowInfo.Valor > 0 ? 
                                parseFloat(rowInfo.Valor).toFixed(2)
                                : '0.00'
                                : '0.00'
                             }
                        </Button>
                    </span>
                </Tooltip>
      
        )
           
            
    }
    
});

const Roow = memo(({
    authTokens, 
    clientSelected, 
    getBancos, 
    getInfoEmpresa,
    handleDelete, 
    handleUpdate, 
    isSyncMk,
    isInvoices, 
    rowInfo, 
    serviceSelected, 
    widthWin, 
    zonaObject, 
})=>{
    const [ openCollapse, setOpenCollapse] = useState(false);
    const [ isReadyPdfInvoice, setReadyPdfInvoice ] = useState(false);
    const [ isReadySubPdfInvoice, setReadySubPdfInvoice ] = useState(false);
    const [ isReadyPdfReciept, setReadyPdfReciept ] = useState(false);
    const [ isReadyPdfThermal, setReadyPdfThermal ] = useState(false);
    const [ getAnulacion, setAnulacion ] = useState('');
    const [ isRAnulacion, setRAnulacion ] = useState(false);
    const [ isProcessingPay, setProcessingPay ] = useState(false);
    const [ isComment, setComment ] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(()=>{
        if(isRAnulacion){
            setRAnulacion(false);          
            handleAnular(); 
        }
    },[isRAnulacion]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCollapse = ()=>{ setOpenCollapse(!openCollapse) }; 

    const handleCreatePdfReciept = ()=>{ setReadyPdfReciept(true) };

    const handleCreatePdfInvoice = ()=>{ setReadyPdfInvoice(true) };

    const handleCreateSubPdfInvoice = ()=>{ setReadySubPdfInvoice(true) };

    const handleClickPdfReciept = ()=>{
        setTimeout(()=>{
            setReadyPdfReciept(false);
        },1000);
    };

    const handleClickPdfInvoice =()=>{
        setTimeout(()=>{
            setReadyPdfInvoice(false);
        },1000);
    };

    const handleClickSubPdfInvoice = ()=>{
        setTimeout(()=>{
            setReadySubPdfInvoice(false);
        },1000);
    };

    const handleAlertDelete = ()=>{
        Swal.fire({
            title: 'DESEA ELIMINAR ESTE RECIBO?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor:'#005596'
        }).then((result) => {
            if (result.isConfirmed) handleDeleteReciept();
        });
    };

    const handleDeleteReciept = ()=>{
        fetch('/api/recibos',{ method:'DELETE', body: JSON.stringify({idReciept:rowInfo._id, NumberInvoice:rowInfo.NumberInvoice ? rowInfo.NumberInvoice : 0}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title: result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                }).then((result) => {
                    handleDelete(rowInfo._id);
                })
            }else{
                Swal.fire({
                    title: result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
            
        })
    };

    const handleAlertAnular  = ()=>{
        setProcessingPay(true);
        Swal.fire({
            title: 'DESEA ANULAR ESTE RECIBO?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor:'#005596'
        }).then((result) => {
            if (result.isConfirmed){
                swal({
                    title: "Ingrese un Motivo",
                    content: {
                      element: "input",
                      attributes: {
                        placeholder: "Referencia",
                        type: "text",
                      },
                    },
                }).then((value2)=>{
                    if(value2){
                        setAnulacion(value2);
                        setRAnulacion(true);
                    }else{
                        setTimeout(()=>{
                            setProcessingPay(false);
                        },500);
                    }
                    
                });
            }else{
                setProcessingPay(false); 
            }
        });
    }

    const handleAnular = ()=>{
        const laZona="America/Guayaquil";
        const laFecha = moment().tz(laZona).format();
        const objeto = {...rowInfo};
        objeto.MotivoAnulacion= getAnulacion;
        objeto.Status = 'Anulado';
        objeto.Modificacion = laFecha;
        fetch('/api/recibos/anular',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result._id){
                enqueueSnackbar('Recibo Anulado',{variant:'success'});
                setAnulacion('');
                handleUpdate(objeto);
                setTimeout(()=>{
                    setProcessingPay(false);
                },500);
            }else{
                enqueueSnackbar(result.status,{variant:'error'});
                setProcessingPay(false);
            }
            
        });
        
        
    };

    const handleActivar = ()=>{
        setProcessingPay(true);
        Swal.fire({
            title: 'DESEA ACTIVAR ESTE RECIBO?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor:'#005596'
        }).then((result) => {
            if (result.isConfirmed){
                const laZona="America/Guayaquil";
                const laFecha = moment().tz(laZona).format();
                const objeto = {...rowInfo};
                objeto.MotivoAnulacion= getAnulacion;
                objeto.Status = 'Pendiente';
                objeto.Modificacion = laFecha;
                fetch('/api/recibos/activar',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                .then(response=> response.json())
                .then(result =>{
                    if(result._id){
                        enqueueSnackbar('Recibo Con Status Pendiente',{variant:'success'});
                        setAnulacion('');
                        handleUpdate(objeto);
                        setTimeout(()=>{
                            setProcessingPay(false);
                        },500);
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});
                        setProcessingPay(false);
                    }
                    
                });
            }
        })
    };

    const handleCreatePdfThermal = ()=>{ setReadyPdfThermal(true) };

    const handleClickPdfThermal = ()=>{
        setTimeout(()=>{
            setReadyPdfThermal(false);
        },1000);
    };

    return(
        <Fragment key={rowInfo._id}>
            <ModalAntd 
                title="COMENTARIO INTERCOM" 
                visible={isComment} 
                onOk={()=>{setComment(false)}} 
                onCancel={()=>{setComment(false)}} 
                okText='CERRAR'
                cancelText='...'
                destroyOnClose
                cancelButtonProps={{disabled:true, display:'none'}}
                >
                    <TextField
                        id='comment_intercom'
                        fullWidth
                        value={rowInfo.commentIntercom || ''}
                        variant='outlined'
                        size='small'     
                        multiline               
                    />
            </ModalAntd> 
            {
                widthWin === 'xs' ||  widthWin === 'sm'?
                <Fragment>
                    <TableRow hover style={{backgroundColor: rowInfo.Status === 'Pagado' ? teal.A400 : rowInfo.isPromise? red.A400 : red[500]}}>
                        <TableCell style={{textAlign:'center'}}>
                            { isInvoices ? rowInfo.NumberInvoice : rowInfo.NumberReciept }
                        </TableCell>
                        <TableCell style={{textAlign:'center'}}>
                            { rowInfo.MesServicio }
                        </TableCell>
                        <TableCell>
                            <Grid container justifyContent='center' spacing={1}>
                                <Grid item>
                                    <ButtonPay 
                                        authTokens={ authTokens }
                                        clientSelected={clientSelected}
                                        getBancos={getBancos}
                                        getInfoEmpresa={getInfoEmpresa}
                                        handleUpdate={handleUpdate} 
                                        isInvoices={isInvoices} 
                                        isSyncMk={isSyncMk}
                                        rowInfo={rowInfo} 
                                        serviceSelected={serviceSelected} 
                                        zonaObject={zonaObject} 
                                    />             
                                </Grid>
                                {rowInfo.Status === 'Pendiente' && <Grid item >
                                    <Tooltip title='ANULAR RECIBO' placement='right' arrow>
                                        <IconButton size="small" onClick={handleAlertAnular} color='primary' disabled={rowInfo.Status === 'Pagado' ? true : false} >
                                            <BlockIcon />
                                        </IconButton>
                                    </Tooltip> 
                                </Grid>}
                                {rowInfo.Status === 'Anulado' &&
                                    <Grid item>
                                        <Tooltip title='ACTIVAR RECIBO' placement='right' arrow>
                                            <IconButton size="small" onClick={handleActivar} color='primary' disabled={rowInfo.Status === 'Pagado' ? true : false} >
                                                <CheckCircleIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                }
                            </Grid>
                        </TableCell>
                    </TableRow>
                </Fragment>
                
                :
                <Fragment>
                    <TableRow hover style={{backgroundColor: rowInfo.Status === 'Pagado' ? teal.A700 : rowInfo.isPromise ?  blue[300] : rowInfo.Valor ? red[500] : red.A400 }}>
                        <TableCell >
                            <Grid container spacing={1}>
                                <Grid item >
                                    <Tooltip title='FACTURA' arrow placement="top">
                                        <span>
                                            <IconButton size="small" onClick={handleCollapse} disabled={isInvoices || rowInfo.Status !== 'Pagado'} style={{backgroundColor:'gainsboro'}} >
                                                {openCollapse ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item >
                                    <Tooltip title='ELIMINAR RECIBO' arrow placement="top">
                                        <span>
                                            <IconButton aria-label="expand row" size="small" onClick={handleAlertDelete} color='primary' style={{backgroundColor:'gainsboro'}} disabled={authTokens.Type === 'ADMINISTRADOR' ? false : true} >
                                                <DeleteIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>  
                                <Grid item>
                                    <Tooltip title='PDF THERMAL' arrow placement="top">
                                        <span>
                                            <IconButton size="small" color='primary' onClick={handleCreatePdfThermal} style={{backgroundColor:'gainsboro'}}>
                                                <RecieptIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                {rowInfo.commentIntercom && rowInfo.commentIntercom !== "" ?
                                <Grid item>
                                    <Tooltip title='COMENTARIO' arrow placement="top">
                                        <span>
                                            <IconButton size="small" color='primary' onClick={()=>{setComment(true)}} style={{backgroundColor:'gainsboro'}}>
                                                <MessageIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>:null}
                                {rowInfo.Status === 'Pendiente' &&
                                <Grid item >
                                    <Tooltip title='ANULAR RECIBO' arrow placement="top">
                                        <span>
                                            <IconButton size="small" onClick={handleAlertAnular} color='primary' disabled={rowInfo.Status === 'Pagado' ? true : false} style={{backgroundColor:'gainsboro'}}>
                                                { isProcessingPay ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : <BlockIcon />}
                                            </IconButton>
                                        </span>
                                    </Tooltip> 
                                </Grid>}
                                {rowInfo.Status === 'Anulado' &&
                                <Grid item >
                                    <Tooltip title='ACTIVAR RECIBO' placement='top' arrow>
                                        <span>
                                            <IconButton size="small" onClick={handleActivar} color='primary' disabled={rowInfo.Status === 'Pagado' ? true : false} style={{backgroundColor:'gainsboro'}}>
                                                { isProcessingPay ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : <CheckCircleIcon />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>}
                                <Grid item >
                                    { 
                                        isInvoices ?
                                        <Tooltip title='PDF FACTURA' arrow placement="top">
                                            <span>
                                                <IconButton size="small" onClick={handleCreatePdfInvoice} color='secondary' style={{backgroundColor:'gainsboro'}}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>:
                                        <Tooltip title='PDF RECIBO' placement='top' arrow>
                                            <span>
                                                <IconButton size="small" onClick={handleCreatePdfReciept} color='secondary' style={{backgroundColor:'gainsboro'}}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    }
                                </Grid>
                                <Grid item>
                                    {isReadyPdfInvoice && <PdfInvoice data={rowInfo} HandleClickPdf={handleClickPdfInvoice} InfoEmpresa={getInfoEmpresa} isSmall={true}/>}
                                    {isReadyPdfReciept && <PdfReciept data={rowInfo} HandleClickPdf={handleClickPdfReciept} InfoEmpresa={getInfoEmpresa} isSmall={true}/>}
                                    {isReadyPdfThermal && <PdfThermal data={rowInfo} HandleClickPdf={handleClickPdfThermal} InfoEmpresa={getInfoEmpresa} Service={serviceSelected} isSmall={true}/>}
                                </Grid>
                            </Grid>
                        </TableCell>
                        <TableCell style={{textAlign:'left', fontWeight:'bolder', color:'#fff'}} size='small'>
                            {isInvoices ? rowInfo.NumberInvoice : rowInfo.NumberReciept}
                        </TableCell>
                        <TableCell style={{textAlign:'left', fontWeight:'bolder', color:'#fff'}} size='small'>
                            {rowInfo.MesServicio.toUpperCase()}
                        </TableCell>
                        <TableCell style={{textAlign:'left'}} size='small'>
                            {rowInfo.Status === 'Anulado' ?
                            <Tooltip title={rowInfo.MotivoAnulacion} placement='top' arrow>
                                <Chip label={rowInfo.Status} color={rowInfo.Status === 'Pagado' ? "primary" : 'secondary'} style={{minWidth:90}}/>
                            </Tooltip>: <Chip label={rowInfo.Status} color={rowInfo.Status === 'Pagado' ? "primary" : 'secondary'} style={{minWidth:90}}/>
                            }
                        </TableCell>
                        <TableCell size='small'>
                            <ValorMes 
                                authTokens={ authTokens }
                                clientSelected={clientSelected}
                                getBancos={getBancos}
                                getInfoEmpresa={getInfoEmpresa}
                                handleUpdate={handleUpdate} 
                                isInvoices={isInvoices} 
                                isSyncMk={isSyncMk}
                                rowInfo={rowInfo} 
                                serviceSelected={serviceSelected} 
                                zonaObject={zonaObject} 
                            />
                        </TableCell>
                        <TableCell style={{textAlign:'left'}} size='small'>
                            <Chip 
                                label={
                                    rowInfo.Status === 'Pagado' ? '$ 0.00' :
                                    rowInfo.Valor ? 
                                    rowInfo.Valor > 0 ? 
                                    `$ ${parseFloat(parseInt(rowInfo.ValTotal) - parseInt(rowInfo.Valor)).toFixed(2)}` 
                                    : '$ 0.00'
                                    : `$ ${rowInfo.ValTotal}`
                                } 
                                style={{background:'red', color:'#fff', fontWeight:'bolder'}}
                            />       
                        </TableCell>
                        <TableCell >
                            <ButtonPay 
                                authTokens={ authTokens }
                                clientSelected={clientSelected}
                                getBancos={getBancos}
                                getInfoEmpresa={getInfoEmpresa}
                                handleUpdate={handleUpdate} 
                                isInvoices={isInvoices} 
                                isSyncMk={isSyncMk}
                                rowInfo={rowInfo} 
                                serviceSelected={serviceSelected} 
                                zonaObject={zonaObject} 
                            />             
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                <Typography variant="h6" gutterBottom component="div">
                                    Factura Recibo
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                    <TableRow>
                                        <TableCell style={{fontWeight:'bolder'}}>Action</TableCell>
                                        <TableCell style={{fontWeight:'bolder'}}>Numero</TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableCell style={{width:150, display:'block'}}>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    { rowInfo.Status === 'Pagado' && 
                                                        <Tooltip title='PDF FACTURA' placement='top' arrow>
                                                            <Fab size="small" onClick={handleCreateSubPdfInvoice} color='primary'>
                                                                <PictureAsPdfIcon />
                                                            </Fab>
                                                        </Tooltip>
                                                    }
                                                </Grid>
                                                <Grid item>
                                                    {isReadySubPdfInvoice && <PdfInvoice data={rowInfo} HandleClickPdf={handleClickSubPdfInvoice} InfoEmpresa={getInfoEmpresa}/>}
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        <TableCell>{rowInfo.Status === 'Pagado' ? rowInfo.NumberInvoice : '0'}</TableCell>
                                    </TableBody>
                                </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </Fragment>
            }   
        </Fragment>
    );
});

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
};
  
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, widthWin } = props;
    const createSorthandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead>
        <TableRow>
            {
                widthWin === 'xs' ||  widthWin === 'sm'?
                <Fragment>
                    {columnsSmall.map((headCell) => (
                        <TableCell
                        key={headCell.id}
                        align='left'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{width:headCell.minWidth}}
                        >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSorthandler(headCell.id)}
                            style={{fontWeight:'bolder'}}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>
                        </TableCell>
                    ))}
                </Fragment>:
                <Fragment>
                {columns.map((headCell) => (
                    <TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                    style={{width:headCell.minWidth}}
                    >
                    <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSorthandler(headCell.id)}
                        style={{fontWeight:'bolder'}}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                        ) : null}
                    </TableSortLabel>
                    </TableCell>
                ))}
            </Fragment>
            }
          
        </TableRow>
      </TableHead>
    );
};

const YounetPago = ({widthWin})=>{
    const classes = styles();
    const { authTokens, setOpen, ageWork, setRuta } = useAuth(); 
    // const [ { isSocket } ] = useContext(StoreContext)  
    const { enqueueSnackbar } = useSnackbar();
    const [ data, setData ] = useState([]);
    const [ clientSelected, setClientSelected ] = useState({Servicios:[{idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''}]});
    const [ serviceSelected, setServiceSelected ] = useState({idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''});
    const [ selectClient, setSelectClient ] = useState(true);
    const [ selectService, setSelectService ] = useState(false);
    const [ isProcesing, setProcesing ] = useState(false);
    const [ dataTable, setDataTable ] = useState([]);
    const [ order, setOrder] = useState('asc');
    const [ orderBy, setOrderBy] = useState('NumberReciept');
    const [ activeService, setActiveService ] = useState(false);
    const [ userName, setUserName ] = useState('');
    const [ dataZona, setDataZona ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState('');
    const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
    const [ isSelectedZona, setSelectedZona ] = useState(false);
    const [ isInvoices, setInvoices ] = useState(false);
    const [ openPagosAnticipados, setOpenPagosAnticipados ] = useState(false);
    const [ openPagosAnticipados2, setOpenPagosAnticipados2 ] = useState(false);
    const [ openReferenciaPagos, setOpenReferenciaPagos ] = useState(false);
    const [ openModalBancario, setOpenModalBancario ] = useState(false);
    const [ isBancario, setBancario ] = useState(false);
    const [ PagosAnticipados, setPagosAnticipados ] = useState({
            ageWork, 
            fechaAct:'', 
            fechaPost:'', 
            isDetalleManual:false,
            MesServicio:'', 
            detalleManual:'',
            valorManual:'',
    });
    const [ isSearchbyNombres, setSearchbyNombres ] = useState(true);
    const [ isReadyRef, setReadyRef ] = useState(false);
    const [ refPago, setRefPago ] = useState('');
    const [ tipoPago, setTipoPago ] = useState('Efectivo');
    const [ arrMesesDis, setArrMesesDis ] = useState([]);
    const [ isValidandoDeposito, setValidandoDeposito ] = useState(false);
    const [ getBancos, setBancos ] = useState([]);
    const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
    const [ getSearch, setSearch ] = useState('');
    const [ getOptionSearch, setOptionSearch ] = useState('Nombres');
    const [ rows, setRows ] = useState([]);
    const [ isOpenSearch, setOpenSearch ] = useState(false);
    const [ getInfoEmpresa, setInfoEmpresa ] = useState({});
    const [ getBanco, setBanco ] = useState('');
    const [ getVoucher, setVoucher ] = useState('');
    const [ isValidandoVoucher, setValidandoVoucher ] = useState(false);
    const [ openModalVoucher, setOpenModalVoucher ] = useState(false);
    const [ fileList, setFileList] = useState([]);
    const [ uploading, setUploading] = useState(false);
    const [ getNombreImagen, setNombreImagen ] = useState('');
    const [ isPhoto, setPhoto ] = useState(false);
    const [ isVoucher, setIsVoucher ] = useState(false);
    const [ isPaying, setPaying ] = useState(false);
    const [ isOpeningPays, setOpeningPays ] = useState(false);
    const [ isSelectedClient, setSelectedClient ] = useState(false);
    const [ isSelectedClientCI, setSelectedClientCI ] = useState(false);
    const [ getSelectedClientV, setSelectedClientV ] = useState('');
    const [ getSelectedClientVCI, setSelectedClientVCI ] = useState('');
    const [ isPaid, setPaid ] = useState(false);
    const [ getZonas, setZonas ] = useState([]);
    const [ allClientes, setAllClientes ] = useState([]);
    const [ backupAllClientes, setBackupAllClientes ] = useState([]);
    const [ isSyncMk, setSyncMk ] = useState(false);

    useEffect(()=>{
        (async ()=>{
            setOpen(false);   
            const PeticionZona = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
            const resultZona = await PeticionZona.json();
            setZonas(resultZona);
            if(authTokens.Type === 'ADMINISTRADOR'){
                setDataZona(resultZona.map(el=> el.Zona));
            }else{
                
                setDataZona(authTokens.Zonas.map(el=> el.Zona)); 
            }
            setRuta('/Servicios/Pagos');
            fetch('/api/clientes/Filtradas',
                { 
                    method:'POST', 
                    body: JSON.stringify({Empresa:authTokens.Empresa, lasZonas:authTokens.Zonas, Tipo:authTokens.Type}), 
                    headers:{'Content-Type': 'application/json'}
                }) 
            .then(response=> response.json())
            .then(result =>{
                const arrAll = [];
                for(const y in result){
                    if(result[y].Servicios.length > 0){ 
                        for(const x in result[y].Servicios){
                            const objeto = {...result[y], ...result[y].Servicios[x]};
                            arrAll.push(objeto);
                        }
                    }
                }
                setAllClientes(arrAll.filter(el=> el !== undefined));
                setBackupAllClientes(arrAll.filter(el=> el !== undefined));
            });
            const getEmpresas = await fetch('/api/Empresas');
            const infEmpresas = await getEmpresas.json();
            const elEmpresa = infEmpresas.find(el=> el.Empresa === authTokens.Empresa);
            const getBanks = await fetch('/api/Bancos');
            const infBanks = await getBanks.json();
            setBancos(infBanks.filter(el=>el.Empresa === authTokens.Empresa));
            setInfoEmpresa(elEmpresa);
        })()
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(selectService){
            setSelectService(false);
            setProcesing(true);
            if(isInvoices){
                fetch('/api/facturas/id',{
                    method:'POST',
                    body: JSON.stringify({id:serviceSelected._id, ageWork}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result=>{
                    if(result.status){
                        enqueueSnackbar(`Error:${result.status}`,{variant:'error'});
                        setProcesing(false);
                    }else{
                        if(result.length === 0){
                            swal("No hay Facturas ",'','info');
                            setProcesing(false);
                        }else{
                            const arrFilter = result.filter(el=> el.ageWork.toString() === ageWork.toString());
                            setDataTable(arrFilter);
                            setProcesing(false);
                        }
                    }
                })
            }else{
                fetch('/api/recibos/id',{
                    method:'POST',
                    body: JSON.stringify({id:serviceSelected._id, ageWork}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result=>{
                    if(result.status){
                        enqueueSnackbar(`Error:${result.status}`,{variant:'error'});
                        setProcesing(false);
                    }else{
                        if(result.length === 0){
                            swal("No hay Recibos ",'','info');
                            setProcesing(false);
                        }else{
                            const arrFilter = result.filter(el=> el.ageWork.toString() === ageWork.toString());
                            setDataTable(arrFilter);
                            setProcesing(false);
                        }
                    }
                })
            }
        }
    },[selectService]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isReadyRef){
            setReadyRef(false);
            if(tipoPago === 'Bancario'){
                handleValidarDeposito();
            }else{
                if(isVoucher){
                    handleValidarVoucher();
                }else{
                    handleSaveAnticipado();
                }
            }
            
        }
    },[isReadyRef]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isSelectedClient){
            handleSelectName(getSelectedClientV);
            setSelectedClient(false);
        }
    },[isSelectedClient]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isSelectedClientCI){
            handleSelectCI(getSelectedClientVCI);
            setSelectedClientCI(false);
        }
    },[isSelectedClientCI]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectName = (value)=>{
        new Promise((resolver, rechazar)=>{
            setUserName(value);
            const arrFil = data.filter(value2=>value2.Nombres.toString() === value.toString());
            if(arrFil.length === 1) resolver(arrFil[0]);
        })
        .then((inf)=>{
            if(inf.Servicios.length > 0){
                //console.log(inf);
                setClientSelected(inf);
                setSelectClient(false);
                setDataTable([]);
            }else{
                swal("Este Cliente no Tiene ningun Servicio Asignado",'',"info");
            }
        })
        .catch((err)=>{
            alert(`Error en el Sistema: ${err}`)
            //console.log(err);
        });
    };

    const handleSelectCI = (value)=>{
        new Promise((resolver, rechazar)=>{
            setUserName(value);
            const arrFil = data.filter(value2=>value2.CI.toString() === value.toString());
            if(arrFil.length === 1) resolver(arrFil[0]);
        })
        .then((inf)=>{
            if(inf.Servicios.length > 0){
                //console.log(inf);
                setClientSelected(inf);
                setSelectClient(false);
                setDataTable([]);
            }else{
                swal("Este Cliente no Tiene ningun Servicio Asignado",'',"info");
            }
        })
        .catch((err)=>{
            alert(`Error en el Sistema: ${err}`)
            //console.log(err);
        });
    };

    const handleSelectTipo = (value)=>{
        setServiceSelected(value);
        setDataTable([]);
        setSelectService(true);
        setActiveService(true);
    };

    const handleClear = ()=>{
        setUserName('');
        setDataTable([]);
        setClientSelected({Servicios:[{idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''}]});
        setServiceSelected({idForMikrotik:'', Plan:'', Direccion:''});
        setSelectClient(false);
        setProcesing(false);
        setDataTable([]);
        setSearchbyNombres(true);
    };

    const handleClearTipServ = ()=>{
        setProcesing(true);
        setActiveService(false);
        setServiceSelected({idForMikrotik:'', Plan:'', Direccion:''});
        setDataTable([]);
        setTimeout(()=>{
            setProcesing(false);
        },1000);
    };

    const handleUpdate = useCallback((props)=>{
        //console.error(props);
        const arr = [];
        for(const x in dataTable){
            if(dataTable[x].MesServicio === props.MesServicio){
                arr.push(props);
            }else{
                arr.push(dataTable[x]);
            }
        };
        setDataTable(arr);
    },[dataTable] ); 

    const handleSelectZona = (valZ)=>{
        setProcesing(true);
        fetch('/api/clientes/byEmpresa&Zona',
            { 
                method:'POST', 
                body: JSON.stringify({Empresa:authTokens.Empresa, Zona:valZ}), 
                headers:{'Content-Type': 'application/json'}
            }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.Status){
                enqueueSnackbar(result.Status, {variant:'error'})
            }else{
                const resultClientes = result.filter(value=>value.Status === 'Activo');
                const arrClientes = [];
                for(const x in resultClientes){
                    const objeto = {...resultClientes[x]};
                    const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService === valZ);
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }
                }
                setData(arrClientes);
                
                setZonaSelected(valZ);
                const arrFil =  getZonas.find(value=> value.Zona === valZ);
                setZonaSelectedObject(arrFil);
                setSyncMk(arrFil.PagosConexion);
                setSelectedZona(true);
                setClientSelected({Servicios:[{idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''}]});
                setServiceSelected({idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''});
                setPagosAnticipados({fechaCorte:'', MesServicio:'', ageWork, isDetalleManual:false, detalleManual:'', valorManual:'' });
                setTipoPago('Efectivo');
                setBanco('');
                setSelectedClientV('');
                setUserName('');
                setSelectClient(false);
                setDataTable([]);
                setProcesing(false);
            }
        });
    };

    const handleClearZona = ()=>{
        setZonaSelected('');
        setZonaSelectedObject({});
        setSelectedZona(false);
        setSelectedClientV('');
        setSelectedClientVCI('');
        setSyncMk(false);
        handleClear();
    };

    const handleInvoices = (checked)=>{ setInvoices(checked) };

    const handleOpenPagosAnticipados = ()=>{
        setOpeningPays(true);
        fetch('/api/recibos/byYear',{ method:'POST', body: JSON.stringify({idForMikrotik:serviceSelected.idForMikrotik, ageWork}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.status){
                enqueueSnackbar(result.status,{variant:'error'});
            }else{
                const arrMesesNo = result.map(el=>el.MesServicio);
                setArrMesesDis(arrMeses.filter(el=> !arrMesesNo.includes(el.toString())))
                setOpenPagosAnticipados(true);
                setOpeningPays(false);
            }
            
        })
    };

    const handleClosePagosAnticipados = ()=>{ 
        setOpenPagosAnticipados(false);
        setPagosAnticipados({fechaCorte:'', MesServicio:'', ageWork, isDetalleManual:false, detalleManual:'', valorManual:''});
        setTipoPago('Efectivo');
        setBanco('');
    };

    const handleConfirmAnticipado = ()=>{
        if(PagosAnticipados.MesServicio === ''){
            alert('SELECCIONE UN MES')
        }else{
            setOpenPagosAnticipados2(true);
        }
        
    };

    const handleFechasAnticipadas = (e)=>{
        const anioAct = ageWork;
        const numMes = parseInt(arrMeses2.indexOf(e.target.value.toString()),10);
        //console.log(numMes);
        // const dayCorte = parseInt(serviceSelected.DiaNotificacion, 10) + parseInt(serviceSelected.DiasCorte, 10);
        const fechaCorteBack  = new Date(`${anioAct}-${numMes}-${parseInt(serviceSelected.DiaNotificacion, 10)}`);
        fechaCorteBack.setDate(fechaCorteBack.getDate() + parseInt(serviceSelected.DiasCorte, 10));
        const fechaCorte = fechaCorteBack.toJSON().split('T')[0]; //fecha de corte
        // if(serviceSelected.TipoPago === 'PrePago'){
            // const fechaCorte = `${anioAct}-${numMes}-${dayCorte}`;
            setPagosAnticipados({...PagosAnticipados, fechaCorte, ageWork:anioAct, MesServicio:e.target.value });
        // }else{
        //     const fechaCorte = `${numMes === 12 ? anioAct + 1 : anioAct}-${numMes === 12 ? 1 : numMes + 1}-${dayCorte}`;
        //     setPagosAnticipados({...PagosAnticipados, fechaCorte, ageWork:anioAct, MesServicio:e.target.value });
        // }
    };

    const handleSaveAnticipado = async ()=>{
        !isPaid && setPaying(true);
        const arrMeses_0 = ['','Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const searchAdicional = await helperDatos({db:'Adicionales', idServicio:serviceSelected._id, MesServicio:PagosAnticipados.MesServicio});
        const searchDescuento = await helperDatos({db:'Descuentos', idServicio:serviceSelected._id, MesServicio:PagosAnticipados.MesServicio});
        const valPlan_ = PagosAnticipados.isDetalleManual ? parseFloat(PagosAnticipados.valorManual).toFixed(2) :  serviceSelected.ValPlan;
        const valAdicional_ =  searchAdicional.length > 0 ? searchAdicional[0].Valor : 0;
        const valAdicional = parseFloat(valAdicional_).toFixed(2);
        const valDescuento_ = searchDescuento.length > 0 ? searchDescuento[0].Valor : 0;
        const valDescuento = parseFloat(valDescuento_).toFixed(2);
        const valIva = (valPlan_ + valAdicional_ - valDescuento) * 0.12;
        const valPlanIva_0 = parseFloat(valPlan_ + valAdicional_ - valDescuento) + parseFloat(valIva);
        const valPlanIva = parseFloat(valPlanIva_0).toFixed(2);
        const valTotal = parseFloat(valPlan_ + valAdicional_ - valDescuento).toFixed(2);
        const valSubTotal = parseFloat(valPlan_ + valAdicional_ ).toFixed(2);
        const objeto = {};
        const laZona = "America/Guayaquil";
        const laFecha = moment().tz(laZona).format().split('T')[0];
        const laFecha2 = moment().tz(laZona).format();
        objeto.fechaCorte = PagosAnticipados.fechaCorte;
        objeto.TipoServicioMk = serviceSelected.TipoServicioMk;
        objeto.ValPlan_ = valPlan_;
        objeto.ValPlan = serviceSelected.ValPlan;
        objeto.Plan = serviceSelected.Plan;
        objeto.MesServicio = PagosAnticipados.MesServicio;
        objeto.isDetalleManual = PagosAnticipados.isDetalleManual;
        objeto.detalleManual = PagosAnticipados.detalleManual;
        objeto.valorManual = PagosAnticipados.valorManual;
        objeto.isIvaManual = PagosAnticipados.isIvaManual;
        objeto.commentIntercom = PagosAnticipados.commentIntercom;
        objeto.NumberMes = arrMeses_0.indexOf(PagosAnticipados.MesServicio);
        objeto.Status = isPaid ? 'Pagado' : 'Pendiente';
        objeto.TipoPagoService = serviceSelected.TipoPago;
        objeto.idServicio = serviceSelected._id;
        objeto.Vendedor = authTokens.Nombres;
        objeto.idForMikrotik = serviceSelected.idForMikrotik;
        objeto.idFromMikrotik = serviceSelected.idFromMikrotik;
        objeto.ZonaService = serviceSelected.ZonaService;
        objeto.PlanComercial = serviceSelected.PlanComercial;
        objeto.RefPago= refPago;
        objeto.TipoPago = isPaid ? tipoPago : '' ;
        objeto.FechaPago = isPaid ? laFecha : '' ;
        objeto.Registro = laFecha2;
        objeto.Modificacion = laFecha2;
        objeto.Nombres = clientSelected.Nombres;
        objeto.ageWork = ageWork;
        objeto.CI = clientSelected.CI;
        objeto.Correo = clientSelected.Correo[0].correo;
        objeto.Celular = clientSelected.Celular[0].celular;
        objeto.idCliente = clientSelected._id;
        // objeto.Valor = valPlan_;
        objeto.AddressIp = serviceSelected.AddressIp;
        objeto.IVA = serviceSelected.IVA;
        objeto.ValIVA = valIva;
        objeto.ValPlanIVA = valPlanIva; 
        objeto.ValIvaFixed = parseFloat(valIva).toFixed(2);
        objeto.isAdicional = searchAdicional.length > 0 ? true : false;
        objeto.isDescuento = searchDescuento.length > 0 ? true : false;
        objeto.DetalleAdicional = searchAdicional.length > 0 ? searchAdicional[0].Detalle : '';
        objeto.DetalleDescuento = searchDescuento.length > 0 ? searchDescuento[0].Detalle : '';
        objeto.idDescuento = searchDescuento.length > 0 ? searchDescuento[0]._id : '';
        objeto.valAdicional =valAdicional;
        objeto.valDescuento = valDescuento;
        objeto.ValTotal = valTotal;
        objeto.subTotal = valSubTotal;
        objeto.isPhoto = isPhoto;
        objeto.Banco = getBanco;
        objeto.numVoucher = getVoucher;
        objeto.urlPhoto = `/refBancarias/${getNombreImagen}`;
        objeto.isPaid = isPaid;
        objeto.Empresa = authTokens.Empresa;
        fetch('/api/pagosanticipados',{ method:'POST', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            //console.log(result);
            if(result._id){
                Swal.fire({title: 'PAGO ANTICIPADO CREADO', icon:'success', confirmButtonColor:'#005596' });
                setBancario(false);
                setRefPago('');
                setTipoPago('Efectivo')
                const arrData = [...dataTable];
                arrData.push(result);
                setDataTable(arrData);
                setPagosAnticipados({
                    fechaAct:'', 
                    fechaPost:'', 
                    MesServicio:'', 
                    ageWork, 
                    isDetalleManual:false,
                    detalleManual:'',
                    valorManual:'',
                    isIvaManual:false
                });
                setOpenModalBancario(false);
                setOpenReferenciaPagos(false);
                setOpenPagosAnticipados2(false);
                setOpenPagosAnticipados(false);
                setPaying(false);
                setPaid(false);
            }else{
                enqueueSnackbar(result.status,{variant:'error'});
                setPaying(false);
                setPaid(false);
            }
            
        });   
    };

    const handleValidarDeposito = ()=>{
        if(refPago === ''){
            alert('INGRESE UN CODIGO DE DEPOSITO')
        }else{
            setValidandoDeposito(true);
            fetch('/api/recibos/validarDeposito',{ method:'POST', body: JSON.stringify({refPago:refPago}), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    enqueueSnackbar(result.message,{variant:'success'});
                    setTimeout(()=>{
                        setValidandoDeposito(false);
                        handleSaveAnticipado();
                    },1000)
                    
                    
                }else{
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
            })
        }
        
    };

    const handleValidarVoucher = ()=>{    
        fetch('/api/recibos/validarVoucher',{ method:'POST', body: JSON.stringify({numVoucher:getVoucher}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message,{variant:'success'});
                setTimeout(()=>{
                    setValidandoVoucher(false);
                    handleSaveAnticipado();
                },1000)
                ();
            }else{
                setValidandoVoucher(false);
                Swal.fire({
                    title: result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                })
            }
        })
    };

    const handleSwitchSearch = (e)=>{ 
        setSearchbyNombres(e.target.checked);
        setUserName('');
        setDataTable([]);
        setClientSelected({Servicios:[{idForMikrotik:'', Plan:'', Direccion:'', TipoServicio:''}]});
        setServiceSelected({idForMikrotik:'', Plan:'', Direccion:''});
        setSelectClient(true);
    };

    const handleDelete = useCallback((idReciept)=>{
        setDataTable(dataT=> dataT.filter(elRecibo=> elRecibo._id !== idReciept));
    },[]);

    const handleClosePagosAnticipados2 = ()=>{
        setOpenPagosAnticipados2(false);
        //setPagosAnticipados({...PagosAnticipados, fechaCorte:'', MesServicio:'', ageWork });
    };

    const handleReferenciaPago = (value)=>{
        if(value === 'Efectivo'){
            setBancario(false);
            setTipoPago(value);
        }else{
            setBancario(true);
            setTipoPago(value);
        }
    };

    const handleContinuoRef = ()=>{
        if(isBancario){
            setOpenModalBancario(true);
        }else{
            if(isVoucher){
                setOpenModalVoucher(true);
            }else{
                setReadyRef(true);
                setPaying(true);
            }
            
        }
    };

    const handleCloseModalBancario = ()=>{
        setOpenModalBancario(false);
        setRefPago('');
        setBanco('');
    };

    const handleCloseTipoPago = ()=>{
        setTipoPago('Efectivo');
        setBancario(false);
        setRefPago('');
        setBanco('');
        setOpenReferenciaPagos(false);   
    };

    const handleSearch = ({target})=>{
        setSearch(target.value);
        if(target.value === ''){
            setRows(backupAllClientes);
        }else{
            setRows(allClientes.filter(el=>el[getOptionSearch].toString().toLowerCase().includes(target.value.toLowerCase())));
        }
    };

    const handleClickMenuBusqueda = (event) => { setOpenMenuBusqueda(event.currentTarget); };

    const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

    const handleOpenSearch = ()=>{ setOpenSearch(true); };

    const handleCloseSearch = ()=>{ setOpenSearch(false); };

    const handleCloseModalVoucher = ()=>{
        setOpenModalVoucher(false);
        setVoucher('');
    };

    const propsUpload = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([...fileList, file]);
            return false;
        },
            fileList,
    };

    const handleUpload = () => {
        if(isPhoto){
            setPaying(true);
            const formData = new FormData();
            fileList.forEach((file) => {
                const d = new Date ();
                const nombreImagen = `${serviceSelected.idForMikrotik}_${PagosAnticipados.MesServicio}_${PagosAnticipados.ageWork}_${d.getTime()}.${file.name.split('.').pop().toString()}`;
                setNombreImagen(nombreImagen);
                formData.append('file', file, nombreImagen);
            });
            setUploading(true); // You can use any AJAX library you like
        
            fetch('/api/uploadRefPago', {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((result) => {
                if(result.message){
                    setFileList([]);
                    enqueueSnackbar('Depósito Subido',{variant:'success'});
                    setReadyRef(true);
                }else{
                    enqueueSnackbar('Fallo con el Servidor',{variant:'error'});
                }
              })
              .catch(() => {
                enqueueSnackbar('Fallo con el Servidor',{variant:'error'});
                setPaying(false);
              })
              .finally(() => {
                setUploading(false);
              });
        }else{
            setReadyRef(true);
            setPaying(true);
        }
        
    };

    const handleSelectedClient = (value)=>{
        setSelectedClientV(value);
        handleClear();
        setSelectedClient(true);
    };

    const handleSelectedClientCI = (value)=>{
        setSelectedClientVCI(value);
        handleClear();
        setSelectedClientCI(true);
    };

    return(
        <Fragment>
            <Backdrop className={classes.backdrop} open={isProcesing} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalAntd 
                title="CREAR RECIBO" 
                visible={openPagosAnticipados} 
                onCancel={handleClosePagosAnticipados} 
                onOk={handleConfirmAnticipado} 
                okText='CONTINUAR'
                cancelText='CANCELAR'
                destroyOnClose
                >
                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                    >
                        <Grid item xs={8} sm={9}>
                            <TextField
                                id='MesServicio'
                                fullWidth
                                label='MesServicio'
                                value={PagosAnticipados.MesServicio || ''}
                                onChange={handleFechasAnticipadas}
                                variant='outlined'
                                type='date'
                                size='small'
                                select
                            >
                                {
                                    arrMesesDis.map((el, index)=>(
                                        <MenuItem value={el} key={`MesServicio_${index}_Anticipado`}>
                                            {el}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>
                        <Grid item xs={4} sm={3} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="SI ACTIVA, SE CREARAN RECIBO Y FACTURA PAGADAS" color='purple'>
                                <SwitchAntd 
                                    checkedChildren='PAGADA' 
                                    onChange={(checked)=>{setPaid(checked)}}
                                    unCheckedChildren="PENDIENTE" 
                                    checked={isPaid || false}
                                />
                            </TooltipAntd>
                        </Grid>
                        <Grid item lg={8} md={6} xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="VALOR Y DETALLE MANUAL?" color='purple'>
                                <CheckboxAntd onChange={({target})=>{setPagosAnticipados({...PagosAnticipados, isDetalleManual:target.checked})}} checked={PagosAnticipados.isDetalleManual || false}>
                                    <Chip label="VALOR Y DETALLE MANUAL?" color='secondary' style={{backgroundColor:'SteelBlue'}}/>
                                </CheckboxAntd>
                            </TooltipAntd>
                        </Grid>
                        {
                            PagosAnticipados.isDetalleManual &&
                            <>
                            <Grid item lg={4} md={6} xs={12}>
                                <TextField 
                                    id='valorManual'
                                    fullWidth
                                    label='Valor'
                                    value={ PagosAnticipados.valorManual || ''}
                                    onChange={({target})=>{ setPagosAnticipados({...PagosAnticipados, valorManual:target.value})}}  
                                    variant='outlined'
                                    InputProps={{
                                        startAdornment:<MonetizationOnIcon/>
                                    }}
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                    id='detalleManual'
                                    fullWidth
                                    label='Detalle'
                                    value={ PagosAnticipados.detalleManual || ''}
                                    onChange={({target})=>{ setPagosAnticipados({...PagosAnticipados, detalleManual:target.value})}}  
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    multiline
                                />
                            </Grid>
                            </>
                        }
                        <Grid item xs={12}>
                            <TextField 
                                id='Comentario'
                                fullWidth
                                label='Comentario'
                                value={ PagosAnticipados.commentIntercom || ''}
                                onChange={({target})=>{ setPagosAnticipados({...PagosAnticipados, commentIntercom:target.value})}}  
                                variant='outlined'
                                size='small'
                                margin='dense'
                                multiline
                            />
                        </Grid>
                    </Grid>
            </ModalAntd> 
            <ModalAntd 
                title="VALIDACION PAGO ANTICIPADO" 
                visible={openPagosAnticipados2} 
                onCancel={handleClosePagosAnticipados2} 
                onOk={()=>{
                    if(isPaid){
                        setOpenReferenciaPagos(true)
                    }else{
                        handleSaveAnticipado()
                    }
                }} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                bodyStyle={{display:'flex', justifyContent:'center'}}
                destroyOnClose
                okButtonProps={{ disabled:!isPaid && isPaying, loading:!isPaid && isPaying }}
                >
                    <Tag color='processing' style={{fontSize:'1rem'}}>
                        {`Mes Servicio: ${PagosAnticipados.MesServicio} || Fecha Corte ${PagosAnticipados.fechaCorte}`}
                    </Tag>
                
            </ModalAntd> 
            <ModalAntd 
                title="TIPO DE PAGO" 
                visible={openReferenciaPagos} 
                onCancel={handleCloseTipoPago} 
                onOk={handleContinuoRef} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                destroyOnClose
                bodyStyle={{display:'flex', justifyContent:'center'}}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <Grid container justifyContent='center'>
                        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
                            <Segmented 
                                value={tipoPago || ''}
                                onChange={handleReferenciaPago}
                                size='small'
                                options={[
                                    {
                                    label: (
                                        <div style={{ padding: 4 }}>
                                        <Avatar style={{ backgroundColor: '#87d068', paddingTop:3 }}  icon={<LocalAtmIcon fontSize='small' />}/>
                                        <div>EFECTIVO</div>
                                        </div>
                                    ),
                                    value: 'Efectivo',
                                    },
                                    {
                                    label: (
                                        <div style={{ padding: 4 }}>
                                        <Avatar style={{ backgroundColor: 'MediumSeaGreen', paddingTop:3 }} icon={<AccountBalanceIcon fontSize='small' />}/>
                                        <div>BANCARIO</div>
                                        </div>
                                    ),
                                    value: 'Bancario',
                                    },
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={1} justifyContent='center' alignItems='center'>
                                <Grid item>
                                    SIN VOUCHER
                                </Grid>
                                <Grid item>
                                    <Switch checked={isVoucher} onChange={({target})=>{ setIsVoucher(target.checked)}} name="isVoucher" color='primary'/>
                                </Grid>
                                <Grid item>
                                    CON VOUCHER
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
            </ModalAntd> 
            <ModalAntd 
                title="REFERENCIA BANCARIA" 
                visible={openModalBancario} 
                onCancel={handleCloseModalBancario} 
                onOk={handleUpload} 
                okText='VALIDAR'
                cancelText='RETROCEDER'
                destroyOnClose
                confirmLoading={isValidandoDeposito}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <React.Fragment>
                        <TextField
                            id='Banco'
                            fullWidth
                            label='Banco'
                            value={getBanco || ''}
                            onChange={({target})=>{setBanco(target.value)}}
                            variant='outlined'
                            size='small'   
                            select  
                            style={{margin:10}}                    
                        >
                            
                            {getBancos.map((el)=>
                                <MenuItem value={el.Banco} key={el._id}>
                                    {el.Banco}
                                </MenuItem>
                            )}
                        </TextField>
                        <TextField
                            id='refPago'
                            fullWidth
                            label='Num. Comprobante Pago'
                            value={refPago || ''}
                            onChange={({target})=>{setRefPago(target.value)}}
                            variant='outlined'
                            size='small'     
                            style={{margin:10}}                 
                        />
                        <Grid container  alignItems="center" spacing={1} style={{margin:10}} justifyContent='center'>
                            <Grid item>NO FOTO</Grid>
                            <Grid item>
                                <Switch checked={isPhoto} onChange={({target})=>{ setPhoto(target.checked)}} name="isPhoto" color='primary'/>
                            </Grid>
                            <Grid item>FOTO</Grid>
                        </Grid>

                        {isPhoto ?
                        <Upload {...propsUpload} >
                            <ButtonAntd 
                                style={{margin:10}} 
                                icon={<UploadOutlined />}
                                loading={uploading}
                            >{uploading ? 'Subiendo' : 'Adjuntar Depósito'}
                            </ButtonAntd>
                        </Upload> : null}
                    </React.Fragment>
            </ModalAntd> 
            <ModalAntd 
                title="BUSQUEDA CLIENTE" 
                visible={isOpenSearch} 
                onCancel={handleCloseSearch} 
                okText=''
                cancelText='CERRAR'
                destroyOnClose
                okButtonProps={{ disabled: true,}}
                width={1000}
                bodyStyle={{maxHeight:500}}
                >
                    <Grid container spacing={0} justifyContent='center'>
                        <Grid item md={6} xs={11}>
                            <TextField 
                                id='SearchOptions'
                                fullWidth
                                label='Busqueda'
                                value={ getSearch || ''}
                                onChange={handleSearch}  
                                variant='outlined'
                                size='small'
                                margin='dense'
                            />
                        </Grid>
                        <Grid item>
                            <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                <span>
                                <IconButton 
                                    color='primary' 
                                    onClick={handleClickMenuBusqueda}  
                                    aria-controls="menu-column-busqueda" 
                                    aria-haspopup="true" 
                                    style={{position:'relative', top:12}}
                                    size='small'
                                >                            
                                    <MoreVertIcon />
                                </IconButton>
                                </span>
                            </Tooltip>
                            <Menu
                                id="menu-column-busqueda"
                                anchorEl={openMenuBusqueda}
                                keepMounted
                                open={Boolean(openMenuBusqueda)}
                                onClose={handleCloseMenuBusqueda}
                            >
                                {
                                    columnsSearch.map((el, index)=>
                                        <MenuItem 
                                            key={`${el.dataIndex}_${index}_`} 
                                            style={{width:'100%'}}
                                            onClick={()=>{
                                                setOptionSearch(el.dataIndex);
                                                setOpenMenuBusqueda(null)
                                            }}
                                        >
                                            {el.title}
                                        </MenuItem>
                                    )
                                }
                            </Menu>   
                        </Grid>
                        <Grid item xs={12}>
                            <TableAntd 
                                columns={columnsSearch} 
                                dataSource={ getSearch === '' ? allClientes.filter(el=> el.Status === 'Activo') : rows } 
                                pagination={{
                                    position: ['none', 'bottomLeft '],
                                }}
                                size='small'
                            />
                        </Grid>
                    </Grid>
            </ModalAntd>
            <ModalAntd 
                title="VOUCHER" 
                visible={openModalVoucher} 
                onCancel={handleCloseModalVoucher} 
                onOk={()=>{ setReadyRef(true); setPaying(true); }} 
                okText='VALIDAR'
                cancelText='RETROCEDER'
                destroyOnClose
                confirmLoading={isValidandoVoucher}
                okButtonProps={{ disabled:isPaying, loading:isPaying }}
                >
                    <React.Fragment>
                        <TextField
                            id='numVoucher'
                            fullWidth
                            label='NUM. VOUCHER'
                            value={getVoucher || ''}
                            onChange={({target})=>{setVoucher(target.value)}}
                            variant='outlined'
                            size='small'     
                                           
                        />
                        
                    </React.Fragment>
                    
                
            </ModalAntd> 
            <Grid container justifyContent='center'style={{padding:10, width:'100%',height:'100%', }}>
                <Grid item xs={12}>
                    <Paper elevation={3} square className={classes.paper}>
                        <Grid container justifyContent='center' spacing={3} alignItems='center'>
                            <Grid item>
                                <IconButton size='small' onClick={handleOpenSearch} color='primary'>
                                    <SearchIcon />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <SwapVerticalCircleIcon style={{color:'green', marginTop:5}}/>
                            </Grid>
                            <Grid item md={3} sm={8} xs={6}>
                                <Autocomplete
                                    id="Zona"
                                    options={dataZona}
                                    value={zonaSelected || ''}                              
                                    renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleClearZona()
                                        }else{
                                            handleSelectZona(value);
                                        }
                                    }}  
                                />
                            </Grid>
                            <Grid item md={1} xs={2} style={{display:'grid', placeContent:'center'}}>
                                <Tooltip title='SYNC MK' placement='top' arrow>
                                <span>
                                    <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={isSyncMk} onChange={(checked)=>{setSyncMk(checked)}} disabled={!isSelectedZona}       />
                                </span>
                                </Tooltip>
                            </Grid>
                            { widthWin === 'xs' || widthWin === 'sm' ?
                                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} style={{display:'flex', justifyContent:'center'}}>
                                    <Switch
                                        checked={isSearchbyNombres}
                                        onChange={handleSwitchSearch}
                                        name="Invoice"
                                        color="primary"
                                        disabled={!isSelectedZona}
                                    />
                                </Grid>:
                                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
                                    <Grid justifyContent='center' container alignItems="center" spacing={1}>
                                        <Grid item>CI</Grid>
                                        <Grid item>
                                            <Switch
                                                checked={isSearchbyNombres}
                                                onChange={handleSwitchSearch}
                                                name="Invoice"
                                                color="primary"
                                                disabled={!isSelectedZona}
                                            />
                                        </Grid>
                                        <Grid item>NOMBRE</Grid>
                                    </Grid>
                                </Grid>
                            }
                            {
                                isSearchbyNombres ?
                                    <Grid item xl={5} lg={5} md={5} sm={10} xs={10} style={{padding:0}}>
                                        <Autocomplete
                                            id="Nombres"
                                            options={data.map(value=>value.Nombres)}
                                            value={userName || ''}           
                                            disabled={!isSelectedZona}                   
                                            renderInput={(params) => <TextField {...params} label="Nombres" variant="outlined" size='small' fullWidth />}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClear()
                                                }else{
                                                    handleSelectedClient(value);
                                                }
                                            }}  
                                        />
                                    </Grid> :
                                    <Grid item xl={5} lg={5} md={5} sm={10} xs={10} style={{padding:0}}>
                                        <Autocomplete
                                            id="CI"
                                            options={data.map(value=>value.CI)}
                                            value={userName || ''}     
                                            disabled={!isSelectedZona}                         
                                            renderInput={(params) => <TextField {...params} label="CI" variant="outlined" size='small' fullWidth />}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClear()
                                                }else{
                                                    handleSelectedClientCI(value);
                                                }
                                            }}  
                                        />
                                    </Grid>
                            }
                            
                            <Grid item xl={1} lg={1} md={1} sm={2} xs={2}>                      
                                <IconButton onClick={handleClear}>
                                    <Tooltip title='Resetear' placement='top' arrow>
                                        <CachedIcon color='primary'/>
                                    </Tooltip>
                                </IconButton>
                            </Grid>                      
                            <Grid item md={6} sm={10} xs={10} style={{padding:0}}>
                                <Autocomplete
                                    id="TipoServicio"
                                    options={clientSelected.Servicios}
                                    value={serviceSelected || ''}
                                    disabled={selectClient}
                                    getOptionLabel={(option) => { return (`ID: ${option.idForMikrotik} - PLAN: ${option.Plan} - DIRECCION: ${option.Direccion}`)}}
                                    renderInput={(params) => <TextField {...params} label="Tipo Servicio" variant="outlined" size='small' margin='dense' fullWidth/>}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleClearTipServ()
                                        }else{
                                            handleSelectTipo(value);
                                        }
                                    }}  
                                />
                            </Grid>            
                            <Grid item md={1} xs={2}>
                                <Tooltip title='Resetear Servicio' placement='top' arrow>
                                    <span>
                                        <IconButton disabled={selectClient} onClick={handleClearTipServ}>
                                                <RefreshIcon color='primary'/>
                                        </IconButton>    
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item md={2} xs={4} style={{padding:0}}>
                                <TextField 
                                    id='Tipo Servicio'
                                    fullWidth
                                    label='Tipo Pago'
                                    value={serviceSelected.TipoPagoBoolean ? 'PrePago' : 'PostPago' || ''}
                                    variant='outlined'
                                    size='small'
                                />   
                            </Grid>
                            <Grid item md={1} xs={4} style={{display:'grid', placeContent:'center'}}>
                                <Tooltip title='VER RECIBOS O FACTURAS' placement='top' arrow>
                                <span>
                                    <SwitchAntd checkedChildren="FACTURAS" unCheckedChildren="RECIBOS" checked={isInvoices} onChange={handleInvoices} disabled={!activeService}/>
                                </span>
                                </Tooltip>
                            </Grid>
                            <Grid item md={1} xs={2} style={{display:'grid', placeContent:'center'}}>
                                <Tooltip title='CREAR RECIBOS PENDIENTES O PAGADOS' placement='top' arrow>
                                    <span>
                                        {
                                            isOpeningPays ?
                                            <FacebookCircularProgress size={20}/> :
                                            <IconButton size='small' onClick={handleOpenPagosAnticipados} color='primary' disabled={!activeService || isOpeningPays}>
                                                <EventIcon/>
                                            </IconButton>
                                        }
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} > 
                                <TableContainer style={{ maxHeight: widthWin === 'xs' ? '43vh' : '59vh', height: widthWin === 'xs' ? '42vh' : '59vh', overflow:'auto' }}>
                                    <Table stickyHeader aria-label="sticky table" size='medium' style={{tableLayout:'fixed'}}>
                                    <EnhancedTableHead
                                        classes={classes}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={dataTable.length}
                                        widthWin={widthWin}
                                        />
                                    <TableBody>
                                    {stableSort(dataTable, getComparator(order, orderBy))
                                    .map((row, index) => {
                                        return (<Roow 
                                                    authTokens={ authTokens }
                                                    key={`${row.id}-${index}_Roow`} 
                                                    rowInfo={row} 
                                                    widthWin={widthWin} 
                                                    handleDelete={handleDelete} 
                                                    isInvoices={isInvoices} 
                                                    handleUpdate={handleUpdate} 
                                                    clientSelected={clientSelected} 
                                                    zonaObject={zonaSelectedObject} 
                                                    serviceSelected={serviceSelected}
                                                    getBancos={getBancos}
                                                    getInfoEmpresa={getInfoEmpresa}
                                                    isSyncMk={isSyncMk}
                                                />);
                                        })}
                                    </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Fragment>
    )
};

const Younet_Pagos= (props)=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
          <YounetPago widthWin={props.width}/>
        </SnackbarProvider>
    );
};

export default withWidth()(Younet_Pagos);
